import { FetchFlightTripDetailsResponse } from "redmond";
import Logger from "../../../utils/logger";
import { fetchFlightTripDetailsV2 } from "../../../api/v2/itinerary-review/fetchFlightTripDetails";
import { store } from "../../../store";
import { actions as flightShopActions } from "../../flight-shop/actions";

interface FetchPackagesTripDetailsArgs {
  searchKey: string;
  tripId: string;
  componentId: number;
}

/**
 * v2 counterpart to `fetchPackagesTripDetailsSaga`: fetches the full trip details for the
 * package's selected flight via the v2 `fetchFlightTripDetails` endpoint, then dispatches the
 * same `SET_PACKAGES_TRIP_DETAILS` action the v0 saga dispatches, so the existing
 * `tripDetailsById` reducer case (and every selector/component reading it, e.g.
 * `ReviewFlightItinerary`) stays version-agnostic once this resolves.
 *
 * `packagesByFareId` is intentionally left empty — the only consumers of its fields
 * (`packagePricing`/`incrementalPricePerTraveler`/`discountInfo` on `PackageFareDetails`) are
 * already optional and have no real reader in `ReviewFlightItinerary`'s render tree.
 */
export const fetchPackagesTripDetailsV2 = async ({
  searchKey,
  tripId,
  componentId,
}: FetchPackagesTripDetailsArgs): Promise<void> => {
  try {
    const response = await fetchFlightTripDetailsV2({
      searchKey: { value: searchKey },
      tripId: { value: tripId },
      componentId: { value: componentId },
    });

    const tripDetailsResponse: FetchFlightTripDetailsResponse = {
      packagesByFareId: {},
      // Structurally identical to redmond's PackageFetchDetailsOpaqueValue
      // ({ type, value }) — the two are just nominally distinct enums for
      // `type` between @capone/packages-api and the local cap1-types copy.
      tripDetailsResponse:
        response.tripDetailsResponse as FetchFlightTripDetailsResponse["tripDetailsResponse"],
    };

    store.dispatch(flightShopActions.setPackagesTripDetails(tripDetailsResponse));
  } catch (e) {
    Logger.debug(e);
    store.dispatch(flightShopActions.setPackagesTripDetailsCallStateFailed(e));
  }
};
